/* =========================================================================
   VOLVER A TI · interactions
   ========================================================================= */
(() => {
  'use strict';

  // ----- Reveal on scroll -----
  const revealObs = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObs.observe(el));

  // ----- Topbar progress + chapter -----
  const topbar       = document.getElementById('topbar');
  const progressFill = document.getElementById('progress-fill');
  const actTag       = document.getElementById('act-tag');
  const topbarLogo   = document.getElementById('topbar-logo');
  const actLabels = {
    1: 'I · El espejo',
    2: 'II · La encrucijada',
    3: 'III · La verdad lenta',
    4: 'IV · Volver a casa',
  };
  const sectionsAct = [...document.querySelectorAll('section[data-act]')];
  function onScroll() {
    const docH = document.documentElement.scrollHeight - window.innerHeight;
    const pct = Math.min(100, Math.max(0, (window.scrollY / docH) * 100));
    if (progressFill) progressFill.style.width = pct + '%';

    const mid = window.scrollY + window.innerHeight * 0.4;
    let currentAct = '1';
    let dark = false;
    for (const sec of sectionsAct) {
      const top = sec.offsetTop;
      const bottom = top + sec.offsetHeight;
      if (mid >= top && mid < bottom) {
        currentAct = sec.dataset.act;
        if (sec.classList.contains('test') || sec.classList.contains('puertas')) dark = true;
        break;
      }
    }
    if (actTag) actTag.textContent = actLabels[currentAct];
    if (topbar) topbar.classList.toggle('dark', dark);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // ----- Verdad quote: word reveal on scroll -----
  const verdadQuote = document.getElementById('verdad-quote');
  if (verdadQuote) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          verdadQuote.classList.add('in');
          obs.unobserve(verdadQuote);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(verdadQuote);
  }

  // ----- Ruta cards line stagger -----
  document.querySelectorAll('.ruta-card').forEach(card => {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          setTimeout(() => card.classList.add('in'), 200);
          obs.unobserve(card);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(card);
  });

  // ----- Timeline emocional -----
  const tlAge   = document.getElementById('tl-age');
  const tlLabel = document.getElementById('tl-label');
  const tlQuote = document.getElementById('tl-quote');
  const tlStops = document.getElementById('tl-stops');
  const tlData = {
    '12': {
      label: 'Tenías',
      age: '12<span class="small">años</span>',
      quote: 'Te peinabas frente al espejo y te gustaba lo que veías. Sin pensar, sin filtros, sin esfuerzo. <em>El pelo era pelo. La cara era cara. Tú eras tú.</em>'
    },
    '18': {
      label: 'Tenías',
      age: '18<span class="small">años</span>',
      quote: 'Empezaste a comprarte cosas. Champú con olor a frutas, gomina, laca. La industria te enseñó a no fiarte de tu cabello. <em>Y aún así, te gustabas.</em>'
    },
    '25': {
      label: 'Tenías',
      age: '25<span class="small">años</span>',
      quote: 'Trabajo, prisa, salidas. Tres champús distintos en la ducha. Los miércoles ibas a la peluquería «porque sí». <em>Aún disfrutabas arreglarte.</em>'
    },
    '35': {
      label: 'Tenías',
      age: '35<span class="small">años</span>',
      quote: 'Algo cambió. Más caída, menos brillo, más productos. Empezaste a probar cosas con miedo. La amiga del botox te dijo «<em>tú también deberías</em>».'
    },
    '45': {
      label: 'Tenías',
      age: '45<span class="small">años</span>',
      quote: 'Ya no te miras como antes. Te arreglas para los demás. <em>Cuidarte se volvió obligación, no disfrute.</em> Tiraste un poco la toalla. Es comprensible.'
    },
    'hoy': {
      label: 'Y',
      age: 'hoy<span class="small">aquí</span>',
      quote: 'Estás leyendo esto. Eso significa algo. <em>Una parte de ti todavía recuerda la chica de los 12.</em> Y quiere volver a verla — desde donde estás ahora.'
    }
  };

  function setAge(age) {
    const d = tlData[age]; if (!d) return;
    if (tlLabel) tlLabel.textContent = d.label;
    if (tlAge) tlAge.innerHTML = d.age;
    if (tlQuote) {
      tlQuote.style.opacity = '0';
      tlQuote.style.transform = 'translateY(8px)';
      setTimeout(() => {
        tlQuote.innerHTML = d.quote;
        tlQuote.style.opacity = '1';
        tlQuote.style.transform = 'none';
      }, 220);
    }
    if (tlStops) {
      tlStops.querySelectorAll('.timeline-stop').forEach(s => {
        if (s.dataset.age === age) s.setAttribute('data-active', '');
        else s.removeAttribute('data-active');
      });
    }
  }

  if (tlStops) {
    tlStops.addEventListener('click', (e) => {
      const stop = e.target.closest('.timeline-stop');
      if (!stop) return;
      setAge(stop.dataset.age);
    });
  }

  // ----- Test del compromiso -----
  const testQuiz   = document.getElementById('test-quiz');
  const testProg   = document.getElementById('test-progress');
  const testResult = document.getElementById('test-result');
  const resultH    = document.getElementById('result-h');
  const resultBody = document.getElementById('result-body');
  const resultStamp = document.getElementById('result-stamp');
  let testAnswers = [];
  let testStep = 0;

  function showQuestion(i) {
    if (!testQuiz) return;
    testQuiz.querySelectorAll('.test-q').forEach(q => q.classList.remove('active'));
    const next = testQuiz.querySelector(`.test-q[data-q="${i}"]`);
    if (next) next.classList.add('active');
    if (testProg) {
      [...testProg.children].forEach((c, idx) => c.classList.toggle('done', idx <= i));
    }
  }

  function computeResult() {
    const total = testAnswers.reduce((a, b) => a + b, 0); // 5 preguntas, 5–15
    let kicker = '— Tu posición en el mapa —';
    let h, body, stamp;
    if (total <= 7) {
      h = 'Ya estás en camino.';
      body = 'Casi todo lo que dices apunta al cuidado real. Lo que viene es ritmo, no dirección. Tu camino ya empezó — solo necesitas las herramientas correctas.';
      stamp = 'A · En camino';
    } else if (total <= 11) {
      h = 'Estás en el umbral.';
      body = 'Sabes que algo no funciona. Aún no has decidido. Está bien — la mayoría de las transformaciones empiezan exactamente ahí, en la duda. Date permiso.';
      stamp = 'B · En el umbral';
    } else {
      h = 'Tiraste un poco la toalla.';
      body = 'Y eso no es un fracaso — es agotamiento. Llevas demasiado tiempo intentando, comprando, dudando. Pasarse a lo natural empieza por dejar de luchar contra ti.';
      stamp = 'C · Tiempo de volver';
    }
    if (resultH) resultH.textContent = h;
    if (resultBody) resultBody.textContent = body;
    if (resultStamp) resultStamp.innerHTML = stamp;
    if (testResult) {
      testQuiz.querySelectorAll('.test-q').forEach(q => q.classList.remove('active'));
      testResult.classList.add('show');
    }
  }

  if (testQuiz) {
    testQuiz.addEventListener('click', (e) => {
      const opt = e.target.closest('.test-opt');
      if (!opt) return;
      const score = parseInt(opt.dataset.score, 10);
      testAnswers.push(score);
      testStep++;
      if (testStep < 5) {
        showQuestion(testStep);
      } else {
        computeResult();
      }
    });
  }

  // ----- Ritual breath -----
  const breath = document.getElementById('breath');
  const breathInner = document.getElementById('breath-inner');
  const ritualWords = document.getElementById('ritual-words');
  if (breath && breathInner) {
    let phase = 0;
    const phases = [
      { label: 'inspira', dur: 4000 },
      { label: 'sostén',  dur: 1500 },
      { label: 'exhala',  dur: 4000 },
      { label: 'descansa', dur: 1500 },
    ];
    let timer = null;
    let active = false;

    breath.addEventListener('click', () => {
      if (active) return;
      active = true;
      breath.classList.add('breathing');
      phase = 0;
      cycle();
      // Reveal words after first cycle
      setTimeout(() => {
        if (ritualWords) ritualWords.classList.add('in');
      }, 4000);
      setTimeout(() => {
        // 90 seconds total
        breath.classList.remove('breathing');
        breathInner.textContent = 'gracias';
        clearTimeout(timer);
        active = false;
      }, 90000);
    });

    function cycle() {
      const p = phases[phase % phases.length];
      breathInner.textContent = p.label;
      timer = setTimeout(() => {
        phase++;
        cycle();
      }, p.dur);
    }
  }

})();
